import { useMutation, useQueryClient } from '@tanstack/react-query'

import type { BookingSessionResponse } from '../../types/booking-session.js'

import { apiClient } from '../../lib/client.js'
import { syncBookingSessionCache } from './cache.js'

export const useRemovePromoCode = (sessionId: string) => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async () => {
      const response = await apiClient.client.delete<BookingSessionResponse>(
        `/booking-session/${sessionId}/promo-code`
      )
      return response.data
    },
    onSuccess: (data) => {
      syncBookingSessionCache(queryClient, data)
    },
  })
}
